import React from 'react';
import classNames from 'classnames';
import Expander, { ExpanderProps } from 'modules/shared/components/expander';
import ExpanderIframe from 'modules/shared/components/expander/expander-iframe';
import ProductDescriptionInterface, { ProductContentTypeEnum } from 'modules/product/interfaces/product-description.interface';

import './product-description.scss';

interface ProductDescriptionProps {
    description: {
        text: ProductDescriptionInterface['text'];
        content: ProductDescriptionInterface['content'];
    };
    className?: string;
    shadowColorGradient?: ExpanderProps['shadowColorGradient'];
    expanded?: ExpanderProps['expanded'];
    anchorIdName?: string;
    onCloseExpander?: () => void;
    isReadMore?: boolean;
}

const NO_DESCRIPTION_TEXT = 'Przepraszamy, ale nie posiadamy obecnie opisu tego produktu.'
    + ' Pracujemy nad tym, by jak najszybciej go uzupełnić dla ciebie.';

const ProductDescription: React.FC<ProductDescriptionProps> = ({
    description,
    className,
    shadowColorGradient = 'white',
    expanded = false,
    anchorIdName,
    onCloseExpander,
    isReadMore = false
}) => {
    const text = description?.content?.text !== null ? description.content.text : NO_DESCRIPTION_TEXT;

    return (
        <div
            className={classNames({
                'product-description': true,
                [String(className)]: Boolean(className)
            })}
        >
            { description.content.type === ProductContentTypeEnum.multimedia
                ? (
                    <ExpanderIframe
                        isReadMore={isReadMore}
                        content={text}
                        minHeight={80}
                        shadowColorGradient={shadowColorGradient}
                        expanded={expanded}
                        anchorIdName={anchorIdName}
                        onClose={onCloseExpander}
                    />
                )
                : (
                    <Expander
                        isReadMore={isReadMore}
                        content={text}
                        minLength={100}
                        shadowColorGradient={shadowColorGradient}
                        expanded={expanded}
                        anchorIdName={anchorIdName}
                        onClose={onCloseExpander}
                    />
                )
            }
        </div>
    );
};

export default ProductDescription;
